import React from "react";
import { MasterImageWrapper } from "../../styles/masterimage.styled";

const Masterimage = () => {
  return (
    <MasterImageWrapper>
      <h1>Explore the Brand New Singapore Flipbook!</h1>
      <text>
        Journey into the best of Singapore with our cool new digital guide, the
        Singapore Flipbook. Turn up the audio to know about Singapore’s wonders,
        gaze at the colourful illustrations or send it to a friend — you’ll have
        everything you need to plan the perfect trip to the Lion City!
      </text>
      <img src="https://cdn1.tripoto.com/media/filter/nxxl/img/1516992/Image/1663838728_flipbook_banner_3.jpg"></img>
    </MasterImageWrapper>
  );
};

export default Masterimage;
